import React, { useEffect, useRef, useState } from "react";
import { useUserStore } from "../../store/userStore.js";
import { Link } from "react-router-dom";
import moment from "moment";
import { Table, ConfigProvider, Input, Select, DatePicker } from "antd";


import images from "../../assets";

const { RangePicker } = DatePicker;

export default function ExpiredUserListData() {
  const { expiredUsers, isLoading, getExpiredUsers } = useUserStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [platform, setPlatform] = useState(null);
  const [plan, setPlan] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [expiredUsers, searchText, platform, dateRange, plan]);

  const fetchOrders = async () => {
    getExpiredUsers();
  };

  const applyFilters = () => {
    let filtered = expiredUsers;

    if (searchText) {
      filtered = filtered?.filter(
        (item) =>
          item?.username?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.id?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    if (platform) {
      filtered = filtered?.filter((item) => item?.platform === platform);
    }
    if (plan) {
      filtered = filtered?.filter((item) => item?.plan === plan);
    }

    if (dateRange?.length === 2) {
      const [startDate, endDate] = dateRange;

      const startOfDay = new Date(startDate).setHours(0, 0, 0, 0);
      const endOfDay = new Date(endDate).setHours(23, 59, 59, 999);

      filtered = filtered?.filter((item) => {
        const orderDate = new Date(item?.expiryDate).getTime();
        return orderDate >= startOfDay && orderDate <= endOfDay;
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleStatusChange = (value) => {
    setPlatform(value);
  };
  const handlePlanChange = (value) => {
    setPlan(value);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "#",
      width: 80,
      fixed: "left",
      render: (text, record, index) =>
        (currentPage - 1) * pageSize + (index + 1),
      key: "2",
    },
    {
      title: "Photo",
      width: 120,
      fixed: "left",
      render: (text, record) => (
        <img
          src={record?.userInfo?.profilePicture}
          className="h-[48px] w-[48px] rounded-xl object-cover"
          alt="pp"
        />
      ),
      key: "2",
    },
    {
      title: "User ID",
      width: 220,
      render: (text, record) => (
        <Link to={`/userprofileoverview/${record?.username}`} target="_blank">
          {record?.username}
        </Link>
      ),
      key: "2",
    },
    {
      title: "Name",
      key: "4",
      render: (text, record) =>
        `${record?.userInfo?.firstName} ${record?.userInfo?.lastName}`,
      width: 200,
      fixed: "left",
    },
    {
      title: "Gender",
      render: (text, record) => record?.userInfo?.gender,
      key: "5",
      width: 90,
    },
    {
      title: "Country",
      key: "6",
      render: (text, record) => record?.userInfo?.country,
      width: 150,
    },
    {
      title: "Age",
      key: "7",
      render: (text, record) =>
        record?.userInfo?.dateOfBirth
          ? moment(record?.userInfo?.dateOfBirth).fromNow().split(" ")[0]
          : null,
      width: 70,
    },
    {
      title: "Profile Completeness",
      render: (text, record) => `${record?.userInfo?.profileCompleteness}%`,
      key: "11",
      width: 130,
    },
    {
      title: "Marital Status",
      key: "8",
      render: (text, record) => (
        <div className="capitalize">
          {record?.userInfo?.maritalStatus === "neverMarried"
            ? "never married"
            : record?.userInfo?.maritalStatus}
        </div>
      ),
      width: 150,
    },
    {
      title: "Email",
      key: "9",
      render: (text, record) => record?.userInfo?.email,
      width: 240,
    },
    {
      title: "Mobile No.",
      key: "10",
      render: (text, record) => record?.userInfo?.phone,
      width: 150,
    },

    {
      title: "Registered Date",
      render: (text, record) =>
        moment(record?.userInfo?.createdAt).format("DD MMMM, YYYY"),
      key: "12",
      width: 200,
    },
    {
      title: "Order Date",
      render: (text, record) =>
        moment(record?.createdAt).format("DD MMMM, YYYY"),
      key: "12",
      width: 200,
    },
    {
      title: "Plan Name",
      key: "11",
      width: 130,
      render: (text, record) => {
        if (!record?.plan) return null;

        const planMapping = {
          PP03: "Platinum",
          PP02: "Gold",
          PP01: "Silver",
        };

        return planMapping[record?.plan] || null;
      },
    },
    {
      title: "Duration",
      key: "6",
      render: (text, record) =>
        record?.duration ? `${record.duration} days` : null,
      width: 150,
    },
    {
      title: "Revenue",
      key: "3",
      width: 130,
      render: (text, record) => record?.amount ?? null,
    },
    {
      title: "Expired date",
      key: "10",
      render: (text, record) =>
        moment(record?.expiryDate).format("DD MMMM, YYYY"),
      width: 130,
    },
    {
      title: "Order Type",
      sorter: true,
      render: (text, record) => record?.orderType,
      key: "13",
      width: 150,
    },
    {
      title: "Payment Type",
      key: "3",
      width: 130,
      render: (text, record) => record?.paymentgateway ?? null,
    },
    {
      title: "Device Type",
      key: "4",
      render: (text, record) => record?.platform ?? null,
      width: 150,
    },
    {
      title: "Order ID",
      width: 200,
      render: (text, record) => record?.id ?? null,
      key: "1",
    },
    {
      title: "Status",
      width: 200,
      render: (text, record) => record?.status ?? null,
      key: "1",
    },
    {
      title: "Sold By",
      width: 200,
      render: (text, record) => record?.soldBy ?? null,
      key: "1",
    },

    {
      title: "Action",
      key: "17",
      fixed: "right",
      width: 230,
      render: (text, record) => (
        <div className="flex flex-col gap-2 justify-center items-center">
          <div className="flex flex-row gap-2 items-center justify-center">
            <img src={images.editIcon} alt="" />

            <img src={images.viewIcon} alt="" />
          </div>

          <div className="flex gap-2">
            <Link
              to={`https://wa.me/${record?.userInfo?.phone}`}
              target="_blank"
            >
              <img src={images.whatsApp} alt="" />
            </Link>

            <Link to={`mailto:${record?.userInfo?.email}`} target="_blank">
              <img src={images.emailBtn} alt="" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-5 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Platform</div>
          <Select
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Filter by platform"
            onChange={handleStatusChange}
            allowClear
            options={[
              { value: "web", label: "Web" },
              { value: "android", label: "Android" },
            ]}
            value={platform}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Plan type</div>
          <Select
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Filter by plan"
            onChange={handlePlanChange}
            allowClear
            options={[
              { value: "PP03", label: "Platinum" },
              { value: "PP02", label: "Gold" },
              { value: "PP01", label: "Silver" },
            ]}
            value={plan}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Date range</div>
          <RangePicker
            style={{ height: 48 }}
            className="moneyPage"
            onChange={handleDateChange}
            allowClear
          />
        </div>
      </div>
      <div>
        Total pages: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isLoading}
          rowKey={() => Math.random()}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}








